<template>
  <div v-if="article" class="article-view">
    <div v-if="article" class="inner">
      <div
        class="general-content-main-container container container-l margin-auto margin-m-vertical l:margin-l-vertical">
        <div class="article-block border-radius relative">
          <div
            class="media-block background-cover"
            :style="`background-image: url('${article.mainImageUrl}');`"></div>
          <div
            class="title-block padding-xl-vertical padding-2xl-horizontal border-radius bg-lead-1">
            <div class="meta flex flex-middle gap-s margin-m-bottom">
              <span class="author text-s c-gray-4">{{ article.Owner.penName }}</span>
              <span class="spacer text-xl c-lead-5">&middot;</span>
              <span class="date text-s c-gray-4">{{
                translateDate(article.createdAt)
              }}</span>
            </div>
            <div class="main-title">
              <h1 class="margin-remove text-2xl l:text-3xl c-bg-1">
                {{ article.title }}
              </h1>
            </div>
          </div>
          <div v-if="article" class="blog-article-content">
            <!-- todo: improve sections - add images -->
            <div v-for="section of article.sections">
              <content-blocks :content="section.content"></content-blocks>
              <div class="article-media-block max-width-600 margin-auto-inline margin-xl-top margin-2xl-bottom l:margin-2xl-top l:margin-max-bottom" v-if="section.image">
                <div class="image-wrapper">
                  <img class="object-contain max-size-parent" :src="section.image" :alt="section.imageAlt">
                </div>
                <div v-if="section.imageCaption && section.imageCaption !== ''" class="margin-s-topimage-caption width-expand text-center c-gray-4 bold">
                  <span>{{section.imageCaption}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="after-article container container-l ">
        <div class="title-zone flex-middle flex-center margin-2xl-top">
          <ag-title
            class="text-center margin-auto-inline"
            align="center">
            {{ tu("ag.article.moreArticles") }}
          </ag-title>
        </div>
        <div class="related-articles margin-auto margin-2xl-top" v-if="relatedArticles">
          <div class="related-container flex gap-2xl flex-column l:flex-row flex-middle l:flex-top flex-center l:flex-between">
            <article-item-intro
              :item="relatedArticle"
              class="related-article  width-expand max-width-400" v-for="relatedArticle of relatedArticles">
              related
            </article-item-intro>
          </div>

        </div>

      </div>
    </div>
    <div v-else class="loading flex-middle flex-center" style="min-height: 50vh">
      <spinner :size="5"></spinner>
    </div>
   </div>
</template>

<script>
import ArticleItemIntro from '@/client/applications/agaloola/components/items/article/Intro.vue';
export default {
  components: {
    ArticleItemIntro
  },
  props: {
    article: {
      type: [Object, Boolean],
      default: false,
    },
    relatedArticles: {
      type: [Object, Boolean],
      default: false,
    },
  },
  data: function () {
    return {};
  },
};
</script>

<style scoped lang="scss">
.media-block {
  width: 100%;
  height: 430px;
  border-radius: var(--border-radius) var(--border-radius) 0 0;

  @media (max-width: 767px) {
    height: 230px;
  }
}

.title-block {
  position: relative;
  max-width: calc(70%);
  min-width: 280px;
  margin-inline: auto;
  top: calc(-1 * var(--margin-2xl));
  margin-bottom: var(--marign-l);

  @media (max-width: 767px) {
    max-width: calc(85%);
  }
}

.main-title h1 {
  line-height: 1.11;
}

.meta {
  span {
    line-height: var(--font-m);

    &.author {
      position: relative;
      top: -0.1em;
    }

    &.spacer {
      position: relative;
      top: -0.1em;
    }
  }
}

.blog-article-content {
  padding-inline: var(--margin-xl);
  padding-bottom: var(--margin-max);

  @media (max-width: 767px) {
    padding-inline: var(--margin-l);
    padding-bottom: var(--margin-2xl);
  }

  :deep(p) {
    line-height: 1.5;
  }
}

.article-block-inner {
  @media (min-width: 767px) {
    padding-inline: var(--margin-max);
    padding-bottom: var(--margin-max);
  }
}

.article-block {
  border: 1px solid var(--c-bg-4);
  background-color: var(--c-bg-5);
}
.general-content-main-container {
  @media (max-width: 767px) {
  }
}
.general-article-content {
  p {
    line-height: 1.55;
  }
}
</style>
